import React, {
  useEffect,
  useImperativeHandle,
  useMemo,
  useState,
} from "react";
import { useNavigate } from "react-router-dom";
import NoRecord from "../../components/NoDataScreen/NoRecord";
import { useLoader } from "../../components/loader/loader";
import Pagination from "../../components/pagination/pagination";
import { ApiUrl } from "../../config/apiConfig";
import { getData, postData } from "../../services/Axios/Axios";
import { PaginationControls } from "../../models/pagination";
import VideoComponet from "../../components/VideoComponet/VideoComponet";
import ImageComponet from "../../components/ImageComponet/imageComponet";
import icon from "../../assets/img/downbtn.svg";
import messageService from "../../services/message/messageService";
import { ChevronsUpDown } from "lucide-react";
import DeleteButton from "../../components/UIElements/DeleteButton";

interface NewList {
  allData: any;
  setAllData: any
}


const MarketResearchList = React.forwardRef((props: NewList, ref) => {
  const { show, hide } = useLoader();
  const [searchdata, setSearchQuery] = useState<any>("");

  const [pagination, setPagination] = useState(new PaginationControls());
  const [startIndex, setStartIndex] = useState(0);
  const [selectedTab, setSelectedTab] = useState(1);
  const [sortConfig, setSortConfig] = useState({
    key: "company_name",
    direction: "ascending",
  });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [singleUser, setsingleUser] = useState<any>("");

  const addEditModalOpen = (data?: any) => {
    if (data) {
      setsingleUser(data);
      setIsModalOpen(true);
    } else {
      setIsModalOpen(true);
    }
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const navigate = useNavigate();
  useEffect(() => {
    MarketResear(searchdata);

    return () => { };
  }, [pagination.page, searchdata]);

  const MarketResear = async (searchdata?: any) => {
    const skip = (pagination.page - 1) * pagination.limit;
    const obj: any = { skip_number: skip };
    if (searchdata) {
      obj.search = searchdata;
    }
    try {
      const response = await getData(ApiUrl.listMarketResearch, obj, {
        show,
        hide,
      });
      console.log(response);
      props.setAllData(response.data);
      setPagination((prevPagination) => ({
        ...prevPagination,
        count: response.total_count,
      }));
      setStartIndex(
        (pagination.page === 0 ? 0 : (pagination.page - 1) * pagination.limit) +
        1
      );
    } catch (error) { }
  };

  const handlePageChange = (selectedPage: { selected: number }) => {
    const newPage = selectedPage.selected + 1;
    setPagination((prevPagination) => ({
      ...prevPagination,
      page: newPage,
    }));
  };

  useImperativeHandle(ref, () => ({
    MarketResear,
    handleSearchSubmit,
    handleSearchChange,
  }));

  const handleSearchChange = (event: any) => {
    setSearchQuery(event);
  };

  const handleSearchSubmit = () => {
    MarketResear(searchdata);
  };

  let deleteData = async (data: any) => {
    const messageServices = messageService();
    messageServices.confirm(`delete this <br/> Advertisement`, "").then(async (res) => {
      if (res.value) {
        const obj = {
          _id: data._id,
          isDeleted: !data.isDeleted,
        };
        let response = postData(ApiUrl.addEditMarketResearch, obj);
        if (await response) {
          MarketResear();
          messageServices.toast(
            "success",
            messageServices.message.deleteSuccess
          );
        }
      }
    });
  };

  const addEdit = (data?: any) => {
    // console.log("object");
    // setSingleBroker(data);
    // setIsModalOpen(true);
  };

  return (
    <>
      <div className="loadlist">
        <div className="tablebox">
          <div className="tablebox12">
            <div className="scrollbar-box newclassscroll">


              <table className="border-collapse  text-black w-full">
                <thead className="whitespace-nowrap bg-[#F6F6F7] border border-[#E2E2E2] ">
                  <tr className="text-[13px] font-bold  bg-customGray">
                    <th className="px-3 py-2 text-center border border-[#E2E2E2] ">
                      <div className="flex items-center justify-between">
                        <span>S. No</span>
                        <ChevronsUpDown size="12px" />
                      </div>
                    </th>

                    <th className="  px-3 py-2 text-center border border-[#E2E2E2]">
                      <div className="flex items-center justify-between">
                        <span>Media</span>
                      </div>
                    </th>

                    <th className="px-3 py-2 text-center border border-[#E2E2E2]">
                      <div className="flex items-center justify-between">
                        <span>Link</span>
                        <ChevronsUpDown size="12px" />
                      </div>
                    </th>

                    <th className="  px-3 py-2 text-center border border-[#E2E2E2]">
                      <div className="flex items-center justify-between">
                        <span>Description</span>
                        <ChevronsUpDown size="12px" />
                      </div>
                    </th>

                    <th className="px-3 py-2 text-center border border-[#E2E2E2]">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="whitespace-nowrap border border-[#E2E2E2] ">
                  {props.allData.map((data: any, index: number) => (
                    <tr key={index} className="text-[12px]">
                      <td className="  px-3  border border-[#E2E2E2]">
                        {startIndex + index}
                      </td>
                      <td className=" px-3 border border-[#E2E2E2]">
                        <ImageComponet
                          data={data.display_content}
                          dataIndex={index}
                        ></ImageComponet>
                      </td>
                      <td className="px-3 border border-[#E2E2E2]">
                        {data?.link}
                      </td>
                      <td className=" px-3 border border-[#E2E2E2]">{data?.description}</td>

                      <td className=" text-center  items-center px-2 py-[2px] border border-[#E2E2E2]">
                        <div className=" w-full flex justify-center gap-1 items-center ">
                          <DeleteButton onClick={() => deleteData(data)} />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {!props.allData.length && (
                <NoRecord noDataText="No data available in Advertisement" />
              )}
            </div>
          </div>
          {props.allData.length > 0 && (
            <Pagination pagination={pagination} onPageChange={handlePageChange} />
          )}
        </div>
      </div>
    </>
  );
});

export default MarketResearchList;
